module.exports = __webpack_public_path__ + "static/media/threeGenerationWomen.f6812243.png";